import React from "react";

const SubmitStep = ({
  validData,
  handleSubmit,
  uploadMsg,
  loading,
  upoloadeStatus,
  uploadStatusData,
  jobId,
  loadingStatus,
  apiValidationError,
}) => {
  const getStatusStyle = (status) => {
    let color;
    switch (status) {
      case "in-progress":
        color = "blue";
        break;
      case "failed":
        color = "red";
        break;
      case "success":
        color = "green";
        break;
      default:
        color = "black";
    }
    return {
      color,
      fontSize: "24px",
    };
  };

  const renderLoader = () => (
    <span className="loader" aria-hidden="true"></span>
  );

  const statusButtonText = loadingStatus ? renderLoader() : "Status";

  const shouldShowStatusButton =
    jobId && uploadStatusData?.status?.toLowerCase?.() !== "failed";

  return (
    <section className="submit-step">
      {loading ? (
        <h2 className="submit-step__title">Uploading… please wait!</h2>
      ) : (
        <>
          <h2
            className={`submit-step__title ${
              uploadMsg &&
              uploadMsg !== "Upload Successful" &&
              uploadMsg !== "Ready to Submit"
                ? "submit-step__title--error"
                : ""
            }`.trim()}
          >
            {uploadMsg === "" ? "Ready to Submit" : uploadMsg}
          </h2>
          {uploadMsg &&
            uploadMsg !== "" &&
            uploadMsg !== "Upload Successful" &&
            !apiValidationError && (
              <p className="recovery-hint">Use “Start Over” to begin again.</p>
            )}
          {apiValidationError && (
            <div className="format-error" role="alert">
              <h4>⚠️ API Validation Failed</h4>
              <p>Records skipped: {apiValidationError.skippedRecords}</p>
              <div className="format-guide">
                <p>Validation Errors:</p>
                <ul>
                  {apiValidationError.validationErrors.map((error, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}
          <div className="status-container" role="status">
            <p style={getStatusStyle(uploadStatusData?.status)}>
              {uploadStatusData?.status
                ? uploadStatusData.status.charAt(0).toUpperCase() +
                  uploadStatusData.status.slice(1)
                : ""}
            </p>
            {jobId && <p>Job ID: {jobId}</p>}
            {shouldShowStatusButton && (
              <button
                type="button"
                onClick={upoloadeStatus}
                className="statusBtn saveBtn"
              >
                {statusButtonText}
              </button>
            )}
          </div>
        </>
      )}
    </section>
  );
};

export default SubmitStep;
